/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MonthlyCount
 */
export interface MonthlyCount {
    /**
     * 月份（1-12）
     * @type {number}
     * @memberof MonthlyCount
     */
    month?: number;
    /**
     * 订单数量
     * @type {number}
     * @memberof MonthlyCount
     */
    count?: number;
    /**
     * 占比(%)
     * @type {number}
     * @memberof MonthlyCount
     */
    percentage?: number;
}

/**
 * Check if a given object implements the MonthlyCount interface.
 */
export function instanceOfMonthlyCount(value: object): value is MonthlyCount {
    return true;
}

export function MonthlyCountFromJSON(json: any): MonthlyCount {
    return MonthlyCountFromJSONTyped(json, false);
}

export function MonthlyCountFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonthlyCount {
    if (json == null) {
        return json;
    }
    return {
        
        'month': json['month'] == null ? undefined : json['month'],
        'count': json['count'] == null ? undefined : json['count'],
        'percentage': json['percentage'] == null ? undefined : json['percentage'],
    };
}

export function MonthlyCountToJSON(json: any): MonthlyCount {
    return MonthlyCountToJSONTyped(json, false);
}

export function MonthlyCountToJSONTyped(value?: MonthlyCount | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'month': value['month'],
        'count': value['count'],
        'percentage': value['percentage'],
    };
}

